import React, {useState, useRef, useEffect} from 'react';
import post from '../utils/post.js';
import FormTextArea from './FormTextArea.js';
import ConfirmPopup from './ConfirmPopup.js';
import usePopupAnimation from '../utils/usePopupAnimation.js';

export default function MessageSysadminEdit({showEdit, closeEdit, updateMessageRowEdit, updateMessageRowDelete, data}) {
	const popupAnimationMs = 300;
	const [loading, setLoading] = useState(false);
	const [note, setNote] = useState('');
	const [noteError, setNoteError] = useState('');
	const [showConfirmPopup, setShowConfirmPopup] = useState(false);

	const noteRef = useRef(null);
	const {shouldRender, isClosing} = usePopupAnimation(showEdit, popupAnimationMs);

	useEffect(() => {
		setNote(data.NOTE || '');
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [showEdit]);

	const handleSubmit = (e) => {
		e.preventDefault();

		setNoteError('');

		let localError = 0;

		if (!note) {
			localError = 1;
			setNoteError('povinné');
			noteRef.current.focus();
		}

		if (localError === 0) {
			setLoading(true);

			post('saveMessageOld', {ID: data.ID, NOTE: note})
				.then((res) => {
					updateMessageRowEdit({ID: data.ID, NOTE: note, NOTES: res.NOTES});

					closeEdit();

					setLoading(false);
				})
				.catch((error) => {
					console.error(error);
					setLoading(false);
				});
		}
	};

	const handleConfirmPopup = (e) => {
		e.preventDefault();
		setShowConfirmPopup(true);
	};

	const closeConfirmPopup = () => {
		setShowConfirmPopup(false);
	};

	const deleteConfirmPopup = () => {
		setLoading(true);

		post('deleteMessage', {ID: data.ID})
			.then((res) => {
				closeConfirmPopup();
				closeEdit();
				updateMessageRowDelete(data.ID);
				setLoading(false);
			})
			.catch((error) => {
				console.error(error);
				setLoading(false);
			});
	};

	return (
		<>
			<ConfirmPopup showConfirmPopup={showConfirmPopup} showButtonDelete deleteConfirmPopup={deleteConfirmPopup} closeConfirmPopup={closeConfirmPopup} infoHeader="Smazání záznamu" infoMain="Opravdu chceš smazat tento záznam?" />

			{shouldRender ? (
				<div className={`popup${isClosing ? ' popup--closing' : ''}`}>
					<div className={`popup_content${isClosing ? ' popup_content--closing' : ''}`}>
						<form method="POST" onSubmit={handleSubmit}>
							<div className="popup_content_in_head">
								<div className="popup_content_in_head_in">Úprava zrávy</div>
								<img
									alt=""
									className="popup_content_in_head_in-close"
									onClick={() => {
										closeEdit();
									}}
								/>
							</div>
							<div className="popup_content_in_body">
								<div className="popup_content_in_body_in">
									<FormTextArea type="text" label="Zpráva" height="25rem" value={note} setValue={setNote} ref={noteRef} error={noteError} />
									<div className="zero h0" />
								</div>
							</div>
							<div className="popup_content_in_foot">
								<div className="popup_content_in_foot_in">
									<input type="submit" name="button_save" value="Uložit" className="button green mr_2" disabled={loading} />
									<button
										type="button"
										className="button red mr_2"
										onClick={(e) => {
											handleConfirmPopup(e);
										}}
									>
										Smazat
									</button>
									<button
										type="button"
										className="button"
										onClick={() => {
											closeEdit();
										}}
									>
										Zpět
									</button>
								</div>
							</div>
						</form>
					</div>
				</div>
			) : (
				''
			)}
		</>
	);
}
